module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar additionalClasses = [];\nif(config.galleryFullHeight)            additionalClasses.push('galleryFullHeight');\nif(config.galleryLandscapeCustomHeight) additionalClasses.push('galleryLandscapeCustomHeight');\nif(config.showFrame)                    additionalClasses.push('showFrame');\n%>\n<div class=\"<%- additionalClasses.join(' ') %>\">\n<%\nif(model.title){\n%><h2><%= model.title %></h2><%\n}\n%>\n<div class=\"frame\">\n<div class=\"galleryColumnWrapper\">\n<%\nfor(var i in (model.images || [])){\n%>\n<%- include('./image', { model: { image: model.images[i], _image: model._images }}); %>\n<%\n}\n%>\n</div>\n<div class=\"gallerySliderWrapper\">\n<div class=\"gallerySlider\"></div>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/sliderGallery/sliderGallery.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var additionalClasses = [];
if(config.galleryFullHeight)            additionalClasses.push('galleryFullHeight');
if(config.galleryLandscapeCustomHeight) additionalClasses.push('galleryLandscapeCustomHeight');
if(config.showFrame)                    additionalClasses.push('showFrame');

    ; __line = 6
    ; __append("\n<div class=\"")
    ; __line = 7
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n")
    ; __line = 8
    ; 
if(model.title){

    ; __line = 10
    ; __append("<h2>")
    ; __append(escapeFn( model.title ))
    ; __append("</h2>")
    ; 
}

    ; __line = 12
    ; __append("\n<div class=\"frame\">\n<div class=\"galleryColumnWrapper\">\n")
    ; __line = 15
    ; 
for(var i in (model.images || [])){

    ; __line = 17
    ; __append("\n")
    ; __line = 18
    ; __append( include('./image', { model: { image: model.images[i], _image: model._images }}) )
    ; __append("\n")
    ; __line = 19
    ; 
}

    ; __line = 21
    ; __append("\n</div>\n<div class=\"gallerySliderWrapper\">\n<div class=\"gallerySlider\"></div>\n</div>\n</div>\n</div>")
    ; __line = 27
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/sliderGallery/sliderGallery.ejs

}